contently.ui.showModal = (modalName) ->
  $("#" + modalName).addClass "active"
  $("body").addClass "modal-active"

$(document).on "click", ".modal-open", (e) ->
  e.preventDefault()
  modalName = $(this).attr("data-modal")
  contently.ui.showModal modalName

  $modal = $(".modal-container.active")
  $modal.trigger "modal:afterOpen"

contently.ui.closeModal = ->
  $modal = $(".modal-container.active")
  $modal.removeClass "active"
  $("body").removeClass "modal-active"

  $modal.trigger "modal:afterClose"

$(document).on "click", ".modal-container", (e) ->
  if $(e.target).is(".js-modal-close")
    if $(".modal-container.active:not(.disable-escape)")
      $(".modal-container.active").trigger("modal:beforeClose")
      contently.ui.closeModal(e)

$(document).keyup (e) ->
  if !$(".modal-container.active").hasClass("disable-escape")
    if e.keyCode is 27
      $(".modal-container.active").trigger("modal:beforeClose")
      contently.ui.closeModal(e)



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/modals.js.coffee